import { render, staticRenderFns } from "./SpecialHighSchoolEduSell.vue?vue&type=template&id=624920c0&scoped=true&"
import script from "./SpecialHighSchoolEduSell.vue?vue&type=script&lang=js&"
export * from "./SpecialHighSchoolEduSell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624920c0",
  null
  
)

export default component.exports